import { Think, ThoughtChain } from '@ant-design/x';
import type { TFunction } from 'i18next';

import type { ChatStreamActivity } from '../../interfaces/ChatStreamActivity';
import { closeOpenStreamActivities, toThoughtChainItems } from './documentChatThoughtChain';

type ActivityCarrier = {
  status?: string;
  streamActivities?: ChatStreamActivity[];
  streamActivity?: ChatStreamActivity;
};

export function resolveStreamActivities(message: ActivityCarrier): ChatStreamActivity[] {
  const activities =
    message.streamActivities && message.streamActivities.length > 0
      ? message.streamActivities
      : message.streamActivity
        ? [message.streamActivity]
        : [];

  if (activities.length === 0) {
    return activities;
  }

  if (message.status === 'Done' || message.status === 'Error' || message.status === 'Cancel') {
    return closeOpenStreamActivities(activities);
  }

  return activities;
}

type Props = {
  t: TFunction;
  activities: ChatStreamActivity[];
  /** Pending → expanded; Done answer arrived → collapsed. */
  defaultExpanded: boolean;
};

/** Collapsible tools list (replaces Document Search agent chip). */
export function StreamToolsPanel({ t, activities, defaultExpanded }: Props) {
  const chainItems = activities.length > 0 ? toThoughtChainItems(t, activities) : [];
  if (chainItems.length === 0) {
    return null;
  }

  return (
    <Think
      title={t('chat.stream.toolsUsed', { count: chainItems.length })}
      defaultExpanded={defaultExpanded}
    >
      <ThoughtChain
        items={chainItems}
        line="solid"
        classNames={{ item: 'text-sm text-neutral-600 dark:text-neutral-300' }}
      />
    </Think>
  );
}
